import styled from 'styled-components';
import COLORS from 'utils/constants/COLORS';
import React from 'react';
import './styles.scss';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';

export const ButtonImage = ({
  type = 'button',
  iconClass = '',
  label = '',
  onClick = () => {},
  disabled = false,
  selected = false,
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      className={classNames('btn-image', {
        'btn-image-active': selected,
      })}
      disabled={disabled}
    >
      <div className="d-flex align-items-center justify-content-center">
        <i className={iconClass+' icon-btnimage'}></i>
        {label}
      </div>
    </Button>
  );
};

export const ButtonImageStyle = styled.button`
  border: #d1d1d1 1px solid;
  width: 100%;
  color: ${(props) => props.textColor || COLORS.white};
  background-color: ${(props) => props.bgColor || 'white'};
  height: 40px;
  font-size: 20px;
  cursor: pointer;
  font-family: 'Futura-Medium', Arial, Helvetica, sans-serif;
`;

export default ButtonImage;
